import { Component, OnInit, Inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { EnumModel } from '../../models/enum-model';
import { OrdersService } from '../../home/services/orders.service';
import {CardsService} from '../../home/services/cards.service';
import {CardCancellationModel} from '../../models/card-cancellation-model';
import {CardCancellationReason} from '../../dto/card-cancellation-reason';

@Component({
  selector: 'app-card-cancellation-dialog',
  templateUrl: './card-cancellation-dialog.component.html',
  styleUrls: ['./card-cancellation-dialog.component.css']
})
export class CardCancellationDialogComponent implements OnInit {
  public title = 'Cancel card';
  public text = 'Are you sure you want to cancel this card?';

  public reasons: EnumModel[];

  public orderId: number;
  public reason: CardCancellationReason;
  public comment: string;

  constructor(
    public dialogRef: MatDialogRef<CardCancellationDialogComponent>,
    private orderService: OrdersService,
    private cardService: CardsService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.cardService.getCancellationReasons().subscribe(result => {
      this.reasons = result;
    });

    if (this.data != null) {
      this.orderId = this.data.orderId;
    }
  }

  onYesClick(): void {
    const model = new CardCancellationModel();
    model.reason = this.reason;
    model.comment = this.comment;

    this.dialogRef.close(model);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
